import { useContext, useEffect, useState } from "react";
import { allDocuments, haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import constants from "../../../Utils/constants";
import LandLordContext from "../../../context/landlord/LandLordContext";
import TenantContext from "../../../context/tenant/TenantContext";
import { useNavigate } from "react-router-dom";
import ProtectedHousingPopup from "../../Tenant/ProtectedHousing";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const TenantEmploymentModal = (props) => {
  const navigate = useNavigate();
  const { user, setUser, id, showModal, setShowModal, fetchTenantDocs } = props;
  const { updateCreatedTenant } = useContext(LandLordContext);
  const tenantContext = useContext(TenantContext);
  const { submitProtectedHousingDocuments } = tenantContext;

  const { _t } = useTranslator();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [formData, setFormData] = useState({
    id: id,
    employment_status: "",
    employment_category: "",
    is_freelancer: false,
    protected_housing: "",
  });
  const [insideModal, setInsideModal] = useState(showModal);
  // const [protectedHousingModal, setProtectedHousingModal] = useState(false);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const handlePropSelect = async (e) => {
    const temp = e.map((val) => ({ label: val?.label, value: val?.value }));
    var placeholder_string = [];

    const selectedValues = temp.map((item) => item.value);

    const tempArr = allDocuments.filter((val) =>
      selectedValues.includes(val?.value)
    );

    tempArr.forEach((val) => {
      placeholder_string.push(
        <span className="placeholder_string">{val?.label}</span>
      );
    });

    if (placeholder_string.length == 0) setSelectBtn(_t("select") + "...");
    else setSelectBtn(placeholder_string);
    setSelectedDocuments(temp);
  };

  useEffect(() => {
    setInsideModal(showModal);
    if (haveValue(user)) {
      setFormData({
        id: id,
        employment_status: user?.employment_status,
        employment_category: user?.employment_category,
        is_freelancer: user?.is_freelancer,
        protected_housing: user?.protected_housing,
      });

      // prefill documents
      const docVals = user?.tenant_extra_field_id?.public_housing_docs || [];
      if (Array.isArray(docVals)) {
        const selectedOptionObjects = allDocuments.filter((opt) =>
          docVals.includes(opt.value)
        );

        setSelectedDocuments(selectedOptionObjects);

        const placeholder_string =
          selectedOptionObjects.length === 0
            ? _t("select") + "..."
            : selectedOptionObjects.map((val) => (
                <span className="placeholder_string" key={val.value}>
                  {val.label}
                </span>
              ));

        setSelectBtn(placeholder_string);
      }
    }
  }, [user]);

  const handleAddProtectedHousingDocuments = async () => {
    try {
      const payload = {
        allDocuments: (selectedDocuments ?? []).map((item) => item?.value),
        llCreated: true,
        user_id: id,
      };
      await submitProtectedHousingDocuments(payload);

      if (fetchTenantDocs) {
        fetchTenantDocs();
      }
      setShowModal(false);
    } catch (err) {
      console.log(err, "error inside handleUploadFile");
    }
  };

  useEffect(() => {
    const tempFunc = () => {
      if (!haveValue(formData?.employment_status)) {
        setButtonDisabled(true);
        return;
      } else if (
        [
          constants.public_servant,
          constants.employed,
          constants.self_employed,
        ].includes(formData?.employment_status ?? "") &&
        !haveValue(formData?.employment_category)
      ) {
        setButtonDisabled(true);
        return;
      }
      setButtonDisabled(false);
    };
    tempFunc();
  }, [formData]);

  const handleInputChangeCategory = (e) => {
    const { value } = e.target;
    if (formData?.employment_status == constants.self_employed) {
      setFormData((prev) => ({
        ...prev,
        is_freelancer: value == "freelancer",
      }));
    }
    // else {
    setFormData((prev) => ({ ...prev, employment_category: value }));
    // }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "protected_housing") {
      setFormData((prev) => ({
        ...prev,
        protected_housing: value === "true",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        employment_status: value,
        employment_category: "",
        is_freelancer: false,
      }));
    }
  };

  const handleSubmitEmployment = () => {
    if (!buttonDisabled) {
      updateCreatedTenant(formData)
        .then((res) => {
          setUser(res.data);
          setShowModal(false);
          setInsideModal(false);
          // setProtectedHousingModal(true);
          // navigate(`/tenant-check/docs/${id}`);
        })
        .catch((err) => {
          console.log("Error inside handleSubmitEmployment", err);
        });
    }
  };

  const allDocuments = [
    {
      value: constants.regulatory_agreement_in_case_of_divorce_separation,
      label: _t(
        "regulatoryAgreementInCaseOfDivorceSeparation",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.revalued_pension_certificate,
      label: _t("revaluedPensionCertificate", "Public Housing Certificates"),
    },
    {
      value: constants.family_book_marriage_civil_partnership_birth_certificate,
      label: _t(
        "familyBookMarriageCivilPartnershipBirthCertificate",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.certificate_of_social_security_compliance,
      label: _t(
        "certificateProvingDisabilityStatus",
        "Public Housing Certificates"
      ),
    },
  ];

  // const handleChangePublicHousing = (e) => {
  //   const temp_data = {
  //     id: id,
  //     protected_housing: e.target.value,
  //   };

  //   updateCreatedTenant(temp_data)
  //     .then((res) => {
  //       setUser(res.data);
  //       // setProtectedHousingModal(false);
  //       setShowModal(false);
  //       navigate(`/tenant-check/docs/${id}`);
  //     })
  //     .catch((err) => {
  //       console.log("Error inside handleSubmitEmployment", err);
  //     });
  // };

  const requiresSubcategory = (status) => {
    return [
      constants.public_servant,
      constants.employed,
      constants.self_employed,
    ].includes(status);
  };

  return (
    <>
      {insideModal && (
        <Modal
          show={insideModal}
          onHide={(e) => {
            setShowModal(false);
            setInsideModal(false);
          }}
          centered
          className="newmodalui asguarantor modal-xl add-landlord-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>
                {_t(
                  "beforeContinuingSelectTenantEmployment",
                  "On LL side while creating TT and providing docs"
                )}
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="two-items-row">
                <div className="forminput mb-0">
                  <label htmlFor="" className="mb-2">
                    {_t("employmentType")}
                  </label>
                  <select
                    className="form-control special-gap"
                    name="employment_status"
                    onChange={handleInputChange}
                    value={formData?.employment_status}
                  >
                    <option value="">{_t("pleaseSelect")}</option>
                    <option value={constants.employed}>{_t("employed")}</option>
                    <option value={constants.self_employed}>
                      {_t("selfEmployed")}
                    </option>
                    <option value={constants.student}>{_t("student")}</option>
                    <option value={constants.unemployed}>
                      {_t("unemployed")}{" "}
                    </option>
                    <option value={constants.retired}>{_t("retired")} </option>
                    <option value={constants.public_servant}>
                      {_t("publicServant")}
                    </option>
                  </select>
                </div>
                <div className="forminput mb-0">
                  {requiresSubcategory(formData?.employment_status ?? "") && (
                    <>
                      <label htmlFor="" className="mb-2">
                        {_t("employmentCategory")}
                      </label>
                      <select
                        className="form-control special-gap"
                        name="employment_category"
                        value={formData?.employment_category}
                        onChange={handleInputChangeCategory}
                      >
                        <option value="">{_t("pleaseSelect")}</option>
                        {(() => {
                          let subcategories = [];
                          if (
                            formData?.employment_status ===
                            constants.public_servant
                          ) {
                            subcategories =
                              constants.public_servant_subcategories;
                          } else if (
                            formData?.employment_status === constants.employed
                          ) {
                            subcategories = constants.employed_subcategories;
                          } else if (
                            formData?.employment_status ===
                            constants.self_employed
                          ) {
                            subcategories = ["ownACompany", "freelancer"];
                          }
                          return subcategories.map((item) => (
                            <option key={item} value={item}>
                              {_t(item)}
                            </option>
                          ));
                        })()}
                      </select>
                    </>
                  )}
                </div>
              </div>
              {formData?.employment_status &&
                (!requiresSubcategory(formData?.employment_status) ||
                  formData.employment_category) && (
                  <div>
                    <label htmlFor="" className="mb-2">
                      {_t(
                        "areYouApplyingOrDoesYourProfileApplyForAPublicHousingProperty",
                        "Public Housing Popup title"
                      )}
                    </label>
                    <div className="two-items-row">
                      <label class="customradiobar forminput cursor-pointer">
                        <input
                          type="radio"
                          name="protected_housing"
                          onChange={handleInputChange}
                          checked={formData.protected_housing === false}
                          value="false"
                        />
                        <div class="boxes">{_t("no")}</div>
                      </label>
                      <label class="customradiobar forminput cursor-pointer">
                        <input
                          type="radio"
                          name="protected_housing"
                          onChange={handleInputChange}
                          checked={formData.protected_housing === true}
                          value="true"
                        />
                        <div class="boxes">{_t("yes")}</div>
                      </label>
                    </div>
                  </div>
                )}
              {formData.protected_housing === true && (
                <div>
                  <label htmlFor="" className="mb-2">
                    {_t("documentType")}
                  </label>
                  <div className="link-property prime-selectmulti multiselect-tenant mb-3">
                    <ReactMultiSelectCheckboxes
                      // key={JSON.stringify(selectedDocuments)}
                      isMulti
                      name="protected_housing_properties"
                      id="protected_housing_properties"
                      options={allDocuments}
                      className="basic-multi-select form-control link_prop_select remove-searchbar"
                      classNamePrefix="select"
                      placeholderButtonLabel={selectBtn}
                      getDropdownButtonLabel={function getDropdownButtonLabe(
                        _ref3
                      ) {
                        return selectBtn;
                      }}
                      selectedOptions={selectedDocuments}
                      onChange={handlePropSelect}
                      defaultValue={selectedDocuments}
                    />
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btngreen add-landlord-submit"
              disabled={
                buttonDisabled ||
                !haveValue(formData?.employment_status) ||
                (requiresSubcategory(formData?.employment_status) &&
                  !haveValue(formData?.employment_category)) ||
                (formData.protected_housing === true &&
                  selectedDocuments.length === 0)
              }
              onClick={() => {
                handleSubmitEmployment();
                handleAddProtectedHousingDocuments();
              }}
            >
              {_t("submit")}
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {/* <ProtectedHousingPopup
        protectedHousingModal={protectedHousingModal}
        setProtectedHousingModal={setProtectedHousingModal}
        isProtectedHousing={user?.protected_housing ?? false}
        handleInputChange={handleChangePublicHousing}
        handleNextStep={handlePublicHousingSubmit}
      /> */}
    </>
  );
};

export default TenantEmploymentModal;
